<div class="wrapper">
  <!-- <app-header></app-header> -->
  <div class="container">
    <div class="form-wrapper">
      <form [formGroup]="findSoldToForm" (ngSubmit)="findSoldTo()">
        <div class="form-group-wrapper">
          <input type="text" class="sold-to-input" id="sold-to-input" aria-describedby="sold to input"
            placeholder="1506214" formControlName="findSoldTo">
          <button class="sold-to-btn" type="submit" [disabled]="!findSoldToForm.valid">Find Sold To</button>
        </div>
        @if (findSoldToForm.controls['findSoldTo'].invalid && (findSoldToForm.controls['findSoldTo'].dirty || findSoldToForm.controls['findSoldTo'].touched)) {
          <p class="error"
            >
            'Find Sold To' input is required.
          </p>
        }
      </form>
    </div>
    @if(cantFindSoldTo){
      <div class="cant-find-soldto">
        <p class="error">Sorry, we can't find your Sold To number.</p>
        <p class="error">Please call Customer Service at 1-800-269-3666</p>
      </div>
    }
    @if(somethingWrong){
      <div class="something-wrong">
        <p class="error">Sorry, we can't complete your request.</p>
        <p class="error">Please try again.</p>
      </div>
    }
  </div>
  @if (optInStatus === 'N') {
    <app-not-in-kscope [optInData]="optInData" [customer]="customer" [userCredential]="userCredential"></app-not-in-kscope>
  }
  @if (optInStatus === 'Y') {
    <app-opted-in [optInData]="optInData" [customer]="customer" [userCredential]="userCredential"></app-opted-in>
  }
  @if (optInStatus === 'Updated') {
    <div class="updated-status">
      <p class="success">Your status has been updated.</p>
    </div>
  }
  @if (optInStatus === 'Error') {
    <div class="error-status">
      <p>Something went wrong with updating the status.</p>
      <p>Please try again.</p>
    </div>
  }
</div>
@if (loadingSpinner === 'true') {
  <app-loading-spinner></app-loading-spinner>
}
